import { InputHTMLAttributes, forwardRef } from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, ...props }, ref) => {
    return (
      <div className="relative inline-flex items-center justify-center">
        <input
          {...props}
          type="checkbox"
          ref={ref}
          className={cn(
            'peer size-4 shrink-0 cursor-pointer appearance-none rounded-[4px] border border-border-primary bg-bg-primary transition',
            'checked:border-brand-solid checked:bg-brand-solid',
            'hover:border-border-brand',
            'focus-visible:ring-4 focus-visible:ring-ring-brand/24',
            'disabled:cursor-not-allowed disabled:opacity-50',
            className,
          )}
        />
        <Check
          className="pointer-events-none absolute size-3 text-white opacity-0 peer-checked:opacity-100"
          aria-hidden="true"
        />
      </div>
    );
  },
);

Checkbox.displayName = 'Checkbox';
